import { render, staticRenderFns } from "./BookingLayouts.vue?vue&type=template&id=78f82756&scoped=true&lang=html&"
import script from "./BookingLayouts.vue?vue&type=script&lang=js&"
export * from "./BookingLayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f82756",
  null
  
)

export default component.exports